export default [

     {
          path: '/user-certificate',
          name: 'UserCertificate',
          component: () => import("@/views/Page/UserCertificate/UserCertificate.vue"),
           meta: {
               title: 'GRC | UserCertificate',
          },
     }
];